import { Button, Card, Col, Form, Row, Select, Tag } from "antd";
import { collection, doc, updateDoc } from "firebase/firestore";
import React, { useState } from "react";
import { db } from "../../../../firebase";

const Amenities = ({ data, dataId, isUpdate,companyName }) => {
  const [isEditActive, setIsEditActive] = useState(false);
  const [isWaiting, setIsWaiting] = useState(false);

  const initialValues = {
    catsAllowed: data?.catsAllowed || "",
    dogsAllowed: data?.dogsAllowed || "",
    amenities: data?.amenities || "",
  };

  const onFinish = (values) => {
    console.log("Success:", values);
    console.log("iididi:", dataId);
    isUpdate(true);
    setIsWaiting(true);
    try {
      const companiesRef = collection(db, "companies");
      const companyDocRef = doc(companiesRef, companyName);
      const propertyDocRef = doc(companyDocRef, "properties", dataId);
      updateDoc(propertyDocRef, {
        "amenities.catsAllowed": values.catsAllowed || "",
        "amenities.dogsAllowed": values.dogsAllowed || "",
        "amenities.amenities": values.amenities || "",
      });

      setTimeout(() => {
        setIsEditActive(false);
        setIsWaiting(false);
      }, 3000);
    } catch (error) {
      console.error("not updated:", error);
      setIsWaiting(false);
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
    setIsWaiting(false);
  };

  return (
    <div>
      <Card
        title="Amenities"
        extra={
          !isEditActive ? (
            <Button
              type="link"
              onClick={() => {
                setIsEditActive(true);
              }}
            >
              Edit
            </Button>
          ) : (
            ""
          )
        }
      >
        <Form
          name="basic"
          labelCol={{
            span: 8,
          }}
          autoComplete="off"
          colon={false}
          initialValues={initialValues}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
        >
          <Form.Item label="Cats Allowed" name="catsAllowed">
            {isEditActive ? (
              <Select
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (option?.label ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                options={[
                  {
                    value: "Yes",
                  },
                  {
                    value: "No",
                  },
                ]}
                style={{ width: "50%" }}
              />
            ) : (
              <p>{data?.catsAllowed === "" ? "--" : data?.catsAllowed}</p>
            )}
          </Form.Item>
          <Form.Item label="Dogs Allowed " name="dogsAllowed">
            {isEditActive ? (
              <Select
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (option?.label ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                options={[
                  {
                    value: "Large & Small",
                  },
                  {
                    value: "Small Only",
                  },
                  {
                    value: "No",
                  },
                ]}
                style={{ width: "50%" }}
              />
            ) : (
              <p>{data?.dogsAllowed === "" ? "--" : data?.dogsAllowed}</p>
            )}
          </Form.Item>
          <Form.Item
            label="Amenities"
            name="amenities"
            extra={isEditActive && <a href="#"> Manage Tags</a>}
          >
            {isEditActive ? (
              <Select
                mode="tags"
                allowClear
                style={{
                  width: "50%",
                }}
                options={[
                  { value: "test1" },
                  { value: "test2" },
                  { value: "test3" },
                  { value: "test4" },
                  { value: "test5" },
                ]}
              />
            ) : (
              <>
                {data?.amenities?.length > 0
                  ? data?.amenities.map((amenities) => (
                      <Tag key={amenities}>{amenities}</Tag>
                    ))
                  : "--"}
              </>
            )}
          </Form.Item>
          {isEditActive && (
            <Row gutter={16}>
              <Col>
                <Button type="primary" htmlType="submit" disabled={isWaiting}>
                  {isWaiting ? "Please wait..." : "Save"}
                </Button>
              </Col>
              <Col>
                <Button
                  onClick={() => {
                    setIsEditActive(false);
                  }}
                >
                  Cancel
                </Button>
              </Col>
            </Row>
          )}
        </Form>
      </Card>
    </div>
  );
};

export default Amenities;
